import React, { useState, useEffect } from "react";
import axios from "axios";

const Address = () => {
  const [fetchedData, setFetchedData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_ContactUs"
      );
      setFetchedData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="container py-5">
      <h2 className="text-center fw-bold mb-4" style={{color:"#920504"}}>
        Contact Us For Any Questions
      </h2>

      <div className="row justify-content-center">
        {fetchedData?.map((item, index) => (
          <div key={index} className="col-12 col-md-4 text-center mb-4">
            <div className="p-3 h-100">
              <h5 className="fw-bold  mb-1" style={{color:"#920504"}}>{item.title}</h5>
              <p className="text-muted mb-0">{item.email}</p>
              <p className="text-muted mb-0">{item.mobile}</p>
              <p className="text-muted mb-0">{item.location}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Address;
